export default function ChevronDown(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width='10' height='5' viewBox='0 0 10 5' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M9.62018 4.75408C9.79327 4.59086 9.79327 4.32626 9.62018 4.16305L5.43909 0.220327C5.12755 -0.0734424 4.62246 -0.0734424 4.31093 0.220327L0.129805 4.16305C-0.0432684 4.32626 -0.0432684 4.59086 0.129805 4.75408C0.302878 4.9173 0.583487 4.9173 0.756558 4.75408L4.87501 0.870447L8.99349 4.75408C9.16651 4.9173 9.44716 4.9173 9.62018 4.75408Z'
        fill='#3253EF'
      />
    </svg>
  );
}
